define("checkout/components/payment/address", ["exports", "@ember/component", "@ember/template-factory", "@glimmer/component", "@ember/object", "@ember/service", "@glimmer/tracking", "ember-concurrency-decorators", "tracked-built-ins", "@ember/runloop"], function (_exports, _component, _templateFactory, _component2, _object, _service, _tracking, _emberConcurrencyDecorators, _trackedBuiltIns, _runloop) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;

  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7;

  0; //eaimeta@70e063a35619d71f0,"@glimmer/component",0,"@ember/object",0,"@ember/service",0,"@glimmer/tracking",0,"ember-concurrency-decorators",0,"tracked-built-ins",0,"@ember/runloop",0,"@ember/template-factory"eaimeta@70e063a35619d71f

  function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }

  function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

  function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }

  function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if this.addressCollectionEnabled}}
    <div data-test-id="address-checkout" class="u--block u--clearfix u--m__b" id="e--addressCheckout" {{did-insert this.getAddress}}>
      {{#if this.showLoadingSpinner}}
        <div class="o--blank u--p__tb__lg">
          <p class="o--blank__desc u--text--center">{{ t "account.subscription.billing.address.loading_message"}}</p>
          <div class="o--blank__img u--relative u--p__lg">
            <Shared::LoadingSpinner/>
          </div>
        </div>
      {{else if this.showEditAddress}}
        <form {{on "submit" (perform this.confirm)}}>
          <Shared::AddressFields
            @country={{this.addressFields.country}}
            @line1={{this.addressFields.line1}}
            @line2={{this.addressFields.line2}}
            @city={{this.addressFields.city}}
            @showErrors={{this.hasAttemptedSave}}
            @state={{this.addressFields.state}}
            @postalCode={{this.addressFields.postalCode}}
            @setSelectedCountry={{this.setSelectedCountry}}
            @setSuggestion={{this.setSuggestion}}
            @isDisabled={{this.isEditDisabled}}
            {{did-insert this.trackViewedForm}}
          />
          <Shared::Ui::Button
            data-test-id="confirm-button"
            class="tCH--btn--primary o--btn--block u--float--right qa--confirm_save_address__btn"
            type="submit"
            @type="default"
            @text={{t "account.subscription.billing.address.confirm"}}
            @isDisabled={{this.isSaveDisabled}}
          />
        </form>
      {{else}}
        <div data-test-id="saved-address" class="u--row u--row--noCollapse u--m__t__md">
          <div class="u--col__9">
            <p class="u--text--bold u--m__b__xs">{{t "account.subscription.billing.address.title"}}</p>
            <span data-test-id="address">
              {{this.address.completedAddress}}
            </span>
          </div>
          <div class="u--col__3 u--text--right">
            <Shared::Ui::Button
              data-test-id="edit-address-button"
              @type="outline"
              @text={{t "shared_words.edit"}}
              @onClick={{@setEditingAddress}}
            />
          </div>
        </div>
      {{/if}}
    </div>
  {{/if}}
  
  */
  {
    "id": "VOZYchwX",
    "block": "[[[41,[30,0,[\"addressCollectionEnabled\"]],[[[1,\"  \"],[11,0],[24,\"data-test-id\",\"address-checkout\"],[24,0,\"u--block u--clearfix u--m__b\"],[24,1,\"e--addressCheckout\"],[4,[38,1],[[30,0,[\"getAddress\"]]],null],[12],[1,\"\\n\"],[41,[30,0,[\"showLoadingSpinner\"]],[[[1,\"      \"],[10,0],[14,0,\"o--blank u--p__tb__lg\"],[12],[1,\"\\n        \"],[10,2],[14,0,\"o--blank__desc u--text--center\"],[12],[1,[28,[35,2],[\"account.subscription.billing.address.loading_message\"],null]],[13],[1,\"\\n        \"],[10,0],[14,0,\"o--blank__img u--relative u--p__lg\"],[12],[1,\"\\n          \"],[8,[39,3],null,null,null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[41,[30,0,[\"showEditAddress\"]],[[[1,\"      \"],[11,\"form\"],[4,[38,4],[\"submit\",[28,[37,5],[[30,0,[\"confirm\"]]],null]],null],[12],[1,\"\\n        \"],[8,[39,6],[[4,[38,1],[[30,0,[\"trackViewedForm\"]]],null]],[[\"@country\",\"@line1\",\"@line2\",\"@city\",\"@showErrors\",\"@state\",\"@postalCode\",\"@setSelectedCountry\",\"@setSuggestion\",\"@isDisabled\"],[[30,0,[\"addressFields\",\"country\"]],[30,0,[\"addressFields\",\"line1\"]],[30,0,[\"addressFields\",\"line2\"]],[30,0,[\"addressFields\",\"city\"]],[30,0,[\"hasAttemptedSave\"]],[30,0,[\"addressFields\",\"state\"]],[30,0,[\"addressFields\",\"postalCode\"]],[30,0,[\"setSelectedCountry\"]],[30,0,[\"setSuggestion\"]],[30,0,[\"isEditDisabled\"]]]],null],[1,\"\\n        \"],[8,[39,7],[[24,\"data-test-id\",\"confirm-button\"],[24,0,\"tCH--btn--primary o--btn--block u--float--right qa--confirm_save_address__btn\"],[24,4,\"submit\"]],[[\"@type\",\"@text\",\"@isDisabled\"],[\"default\",[28,[37,2],[\"account.subscription.billing.address.confirm\"],null],[30,0,[\"isSaveDisabled\"]]]],null],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],[[[1,\"      \"],[10,0],[14,\"data-test-id\",\"saved-address\"],[14,0,\"u--row u--row--noCollapse u--m__t__md\"],[12],[1,\"\\n        \"],[10,0],[14,0,\"u--col__9\"],[12],[1,\"\\n          \"],[10,2],[14,0,\"u--text--bold u--m__b__xs\"],[12],[1,[28,[35,2],[\"account.subscription.billing.address.title\"],null]],[13],[1,\"\\n          \"],[10,1],[14,\"data-test-id\",\"address\"],[12],[1,\"\\n            \"],[1,[30,0,[\"address\",\"completedAddress\"]]],[1,\"\\n          \"],[13],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,0],[14,0,\"u--col__3 u--text--right\"],[12],[1,\"\\n          \"],[8,[39,7],[[24,\"data-test-id\",\"edit-address-button\"]],[[\"@type\",\"@text\",\"@onClick\"],[\"outline\",[28,[37,2],[\"shared_words.edit\"],null],[30,1]]],null],[1,\"\\n        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]],[]]],[1,\"  \"],[13],[1,\"\\n\"]],[]],null]],[\"@setEditingAddress\"],false,[\"if\",\"did-insert\",\"t\",\"shared/loading-spinner\",\"on\",\"perform\",\"shared/address-fields\",\"shared/ui/button\"]]",
    "moduleName": "checkout/components/payment/address.hbs",
    "isStrictMode": false
  });

  let PaymentAddress = (_class = class PaymentAddress extends _component2.default {
    constructor() {
      super(...arguments);

      _initializerDefineProperty(this, "address", _descriptor, this);

      _initializerDefineProperty(this, "alerts", _descriptor2, this);

      _initializerDefineProperty(this, "intl", _descriptor3, this);

      _defineProperty(this, "DEFAULT_LOADING_STATE_THRESHOLD_IN_MS", 3000);

      _initializerDefineProperty(this, "hasAttemptedSave", _descriptor4, this);

      _initializerDefineProperty(this, "showEdit", _descriptor5, this);

      _initializerDefineProperty(this, "addressFields", _descriptor6, this);

      _initializerDefineProperty(this, "showLoadingSpinner", _descriptor7, this);
    }

    get addressCollectionEnabled() {
      return this.address.addressCollectionEnabled;
    }

    get isEditDisabled() {
      return this.confirm.isRunning;
    }

    get isSaveDisabled() {
      return this.hasAttemptedSave && (!this.address.canAttemptSave || !this.address.hasRequiredFields(this.addressFields));
    }

    get showEditAddress() {
      return this.args.isEditingAddress;
    }

    getAddress() {
      this.addressFields = new _trackedBuiltIns.TrackedObject(this.address.savedAddressFields);
      this.address.resetForm();

      if (!this.address.isSavedAddressValid) {
        this.args.setEditingAddress();
      }
    }

    trackViewedForm() {
      this.address.trackViewedForm(this.address.savedAddressFields, 'checkout');
    }

    setSelectedCountry(country) {
      this.addressFields.country = country;
    }

    setSuggestion(addressField, suggestedValue) {
      this.addressFields[addressField] = suggestedValue;
    }

    *confirm(event) {
      event.preventDefault();
      this.hasAttemptedSave = true;
      this.address.trackClickedSave(this.addressFields, 'checkout'); // Note: If validation is rate limiting, this might take longer than expected. We want to show a loading state when retrying.

      (0, _runloop.later)(() => {
        if (this.address.validateAddress.isRunning) {
          this.showLoadingSpinner = true;
          this.address.trackViewedLoadingSpinner(this.addressFields, 'checkout');
        }
      }, this.DEFAULT_LOADING_STATE_THRESHOLD_IN_MS);

      try {
        const isAddressValid = yield this.address.validateAddress.perform(this.addressFields);

        if (!isAddressValid) {
          this.address.trackViewedValidationError(this.addressFields, 'checkout');
          return;
        }

        yield this.address.save.perform(this.addressFields);
        this.address.trackSavedSuccessfully(this.addressFields, 'checkout');
        this.alerts.success(this.intl.t('alerts.account.address.success.message'), {
          title: this.intl.t('alerts.account.address.success.title')
        });
        this.args.hideEditingAddress();
      } catch ({
        alert
      }) {
        this.address.trackViewedServerError(this.addressFields, 'checkout');
        this.alerts.add(alert);
      } finally {
        this.showLoadingSpinner = false;
      }
    }

  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "address", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "alerts", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "intl", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "hasAttemptedSave", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "showEdit", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "addressFields", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return new _trackedBuiltIns.TrackedObject({});
    }
  }), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "showLoadingSpinner", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return false;
    }
  }), _applyDecoratedDescriptor(_class.prototype, "getAddress", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "getAddress"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "trackViewedForm", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "trackViewedForm"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSelectedCountry", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSelectedCountry"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "setSuggestion", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setSuggestion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "confirm", [_emberConcurrencyDecorators.dropTask], Object.getOwnPropertyDescriptor(_class.prototype, "confirm"), _class.prototype)), _class);
  _exports.default = PaymentAddress;
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, PaymentAddress);
});